import { useState, type FormEvent } from 'react'
import { authApi, type Me } from '../../lib/auth'
import { BTN_PRIMARY, Card, Field, INPUT, Notice } from './AuthUi'
import { ForgotPasswordForm } from './ForgotPasswordForm'

// Logowanie e-mailem (nowe konta: login = e-mail) albo dawnym loginem bez „@".
// „Nie pamiętasz hasła?" przełącza tę samą kartę na prośbę o link — bez osobnej trasy,
// więc działa wszędzie, gdzie stoi formularz (/konto, /admin, ekran bramki, okno 401).
export function LoginForm({ onLoggedIn, subtitle }: { onLoggedIn: (me: Me) => void; subtitle?: string }) {
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState<string | null>(null)
  const [forgot, setForgot] = useState(false)

  const submit = (e: FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setErr(null)
    authApi.login(login.trim(), password).then(
      (me) => onLoggedIn(me),
      (e: Error) => { setErr(e.message); setPassword(''); setBusy(false) },
    )
  }

  const toggle = (
    <button
      type="button"
      onClick={() => { setForgot((f) => !f); setErr(null) }}
      className="self-start text-xs font-medium text-forest-700 hover:underline"
    >
      {forgot ? '← Wróć do logowania' : 'Nie pamiętasz hasła?'}
    </button>
  )

  if (forgot) {
    return (
      <div className="mx-auto max-w-sm">
        <Card title="Nie pamiętasz hasła?" subtitle="Podaj e-mail konta — wyślemy link do ustawienia nowego hasła.">
          <div className="flex flex-col gap-3">
            <ForgotPasswordForm initialEmail={login.includes('@') ? login.trim() : ''} />
            {toggle}
          </div>
        </Card>
      </div>
    )
  }

  return (
    <div className="mx-auto max-w-sm">
      <Card title="Logowanie" subtitle={subtitle}>
        <form onSubmit={submit} className="flex flex-col gap-3">
          {err && <Notice tone="error">{err}</Notice>}
          <Field label="E-mail">
            <input
              className={INPUT} value={login} onChange={(e) => setLogin(e.target.value)}
              autoComplete="username" autoCapitalize="none" spellCheck={false} autoFocus required
            />
          </Field>
          <Field label="Hasło">
            <input
              className={INPUT} type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password" required
            />
          </Field>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <button type="submit" disabled={busy || !login.trim() || !password} className={BTN_PRIMARY}>
              {busy ? 'Logowanie…' : 'Zaloguj'}
            </button>
            {toggle}
          </div>
        </form>
      </Card>
    </div>
  )
}
